<ngx-avatar name="{{user.name}}" fgColor="#000" bgColor="#f8e71c" size="50" [round]="true" class="avatar"></ngx-avatar>
<p class="name">{{user.name}}</p>
<p clasS="email">{{user.email}}</p>
